import { BaseModalDeprecated } from '@randstad-lean-mobile-factory/react-components-core';
import { useHistory } from 'react-router-dom';

import OfferDetail from 'src/Components/OfferDetail';

const OfferModal = () => {
  const history = useHistory();
  return (
    <BaseModalDeprecated
      open
      onClose={() => {
        history.replace('/');
      }}
      lockScroll
    >
      {(close: () => void) => (
        <OfferDetail
          onRequestClose={() => {
            close();
          }}
        />
      )}
    </BaseModalDeprecated>
  );
};

export default OfferModal;
